/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Period_AllInputs */

const vi_order_period_all = /** @type {(inputs: Order_Period_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toàn thời gian`)
};

/**

* @param {Order_Period_AllInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_period_all = /** @type {((inputs?: Order_Period_AllInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Period_AllInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_period_all(inputs)
});